module.exports = __webpack_public_path__ + "img/icon_big.908e819e.png";